import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { selectKnowledgeBase } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReadyOnlyInput() {
  const {
    domain,
    slug
  } = useAppSelector(selectKnowledgeBase);
  const url = `${domain}/${slug}`;
  function I18nText(messageKey) {
    return I18n.text(`knowledgeContentUI.templateEditor.fields.${messageKey}`);
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18nText('knowledgeBaseNameURL.label'),
    tooltip: I18nText('knowledgeBaseNameURL.helpText'),
    children: /*#__PURE__*/_jsx(TextInput, {
      readOnly: true,
      value: url || ''
    })
  });
}